/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Questions({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14 .5a2 2 0 0 1 2 2v3.897c0 1.103-1.2 1.103-1.2 0V2.5a.8.8 0 0 0-.8-.8H7l-.082.004A.8.8 0 0 0 6.2 2.5v3.897l.004.082A.8.8 0 0 0 7 7.197h.069c.373 0 .625.388.538.75-.06.25-.274.45-.53.45H7a2 2 0 0 1-2-2V2.5a2 2 0 0 1 2-2z" /><path fill="currentColor" d="M11.356 12.522a.84.84 0 1 1-.001 1.679.84.84 0 0 1 .001-1.68M11.486 6a2.226 2.226 0 0 1 1.38 3.974l-.537.422a.98.98 0 0 0-.373.77v.044a.6.6 0 0 1-1.2 0v-.044c0-.667.306-1.298.83-1.71l.536-.424a1.026 1.026 0 0 0-.636-1.832h-.13c-.638 0-1.156.518-1.156 1.156v.22a.601.601 0 0 1-1.2 0v-.22A2.357 2.357 0 0 1 11.356 6zM3.8 3.6a.6.6 0 0 1-.6.6H2a.8.8 0 0 0-.8.8v3.897a.8.8 0 0 0 .8.8h.315a1 1 0 0 1 1 1v.254l1.315-.946.004-.003.016-.015c.218-.187.496-.29.784-.29H7.12c.205 0 .39.125.484.308.197.383-.06.893-.492.893h-1.68q-.033.03-.07.059l-2.455 1.768a.5.5 0 0 1-.792-.407v-1.42H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1.2a.6.6 0 0 1 .6.6" /></svg>;
}
;